export default {
  pending: 'Pending',
  lost: 'Locator Not Recovered',
  recovered: 'Locator Recovered'
};